import React, {useRef, useState} from 'react'
import { connect } from 'react-redux'
import styles from './variants.scss'
import { 
    getVariantFlags,
    showEditVariantSlider,
    showVariantTypeSlider, 
    setVariantProductData,
    showMoreDetailsSlider,
    showSettingsSlider,
    syncImageUpload,
    showVariantDetailsSlider
} from '../../../actions/variants'
import { deleteVideoUrlIdsFromAllProducts } from '../../../actions/products';
import VariantProductList from './VariantProductList';
import Button from 'jd-library/Button'
import MoreMenu from 'jd-library/MoreMenu'
import UpgradeModal from 'jd-library/UpgradeModal'
import toastMessageActions from 'jd-library/toastMessageActions';
import { getImagePath } from '../../../common/fileUtills';
import { updateVideoInLibrary } from '../../../actions/videoLibrary';
import withRipple from 'jd-library/withRipple';
import withPortal from 'jd-library/withPortal';
import { updateEditProductDetail } from '../../../actions/products'

const UpgradeModalWeb = withPortal(UpgradeModal);

const VariantSection = (props) => {
    const {colorPresent} = getVariantFlags(props.variantData);
    const imageIndex = useRef(null);
    const [premiumModal, setPremiumModal] = useState(false);
    const [showAll, setShowAll] = useState(false);

    const onEditClick = () => {
        // props.showVariantDetailsSlider({
        //     show: true,
        //     mode: 'edit'
        // })
        props.updateEditProductDetail([{
            key: 'isEdit',
            value: true
        }])
        props.showEditVariantSlider(true);
    }

    const modalProps = {
        className: styles['premium-variant-modal'],
        imageUrl: 'https://image1.jdomni.in/jdomni_email/premiumPackageImg.png',
        title: 'Upgrade to Premium to Add Product Variants',
        subtext: <div className={styles['subtext-padding']}>Create multiple variants to a product that comes in more than one options such as size, color, etc.
            <div className={styles['patch-note']}>Please note that you can click on continue button to experience the feature, but you won't be able to save your changes till you upgrade to premium</div>
        </div>,
        btnArray: [
            {
                children: 'Cancel',
                onClick: ()=>window.history.back(),
                className: styles['left-button']
            },
            {
                children: 'Continue',
                onClick: ()=>{
                    window.history.back();
                    setTimeout(()=>{
                        props.showEditVariantSlider(true)
                        props.showVariantTypeSlider({show: true,mode: 'add', from: 'homepage'})
                    }, 500)
                },
                className: styles['right-button']
            }
        ],
        onHidden: ()=>setPremiumModal(false)
    }

    const uploadImage = (res) => {
        //#TO_DO - Make Single Function
        let temp = [...props.variantProductData]
        let saveData = true;
        if(res.forVideo){
            if(res.initialReq){
                temp[imageIndex.current].videoUrlArr.push(res.imageUrl);
                props.updateVideoInLibrary({...res.imageUrl, isVariantProduct: true}) //Add the Video to the Library
            }else{
                if(!res.imageUrl.videoId){
                    //Generate the Video ID for uploaded videos
                    saveData = false;
                    props.updateVideoInLibrary({...res.imageUrl, variantId: "", isVariantProduct: true, cb: (id)=>{
                        temp[imageIndex.current].videoUrlArr[0] = ({...res.imageUrl, uploaded: true, videoId: id});
                        if(colorPresent && props.syncImages){
                            temp = syncImageUpload(temp, props.variantCombinations, imageIndex.current);
                        }
                        props.setVariantProductData(temp);
                    }})
                }else{
                    temp[imageIndex.current].videoUrlArr[0] = ({...res.imageUrl, uploaded: true})
                }
            }
        }else{
            let toastMsg = '';
            if(res.createdfrom == 'url'){
                res.imageUrl = {
                    uploaded: true,
                    imgURL: res.imgURL,
                    actualPath: getImagePath(res.imgURL)
                }
                temp[imageIndex.current].imageUrlArr.push(res.imageUrl)
            }else if(res.createdfrom == 'photoGallery' || res.createdfrom == 'copyImages'){
                temp[imageIndex.current].imageUrlArr.push(...res.imageUrlArr);
                toastMsg = res.createdfrom == 'copyImages' ? '' : toastMsg;
            }else if(res.imageUrl.uploaded){
                for(let i=0;i<temp[imageIndex.current].imageUrlArr.length;i++){
                    if(temp[imageIndex.current].imageUrlArr[i].imgIndex == res.imgIndex){
                        temp[imageIndex.current].imageUrlArr[i] = res.imageUrl
                    }
                }
            }else{
                toastMsg = '';
                temp[imageIndex.current].imageUrlArr.push(res.imageUrl)
            }
            if(toastMsg){
                props.showToastMessage({
                    showToastMessage: true,
                    message: toastMsg,
                    type: 'info',
                    duration: 5000
                });
            }  
        }
        if(colorPresent && props.syncImages){
            temp = syncImageUpload(temp, props.variantCombinations, imageIndex.current);
        }
        saveData && props.setVariantProductData(temp);
        return temp[imageIndex.current];
    }

    const uploadOptionProps = {
        type: props.uploadOptions?.type,
        onFileUpload: res=>uploadImage(res),
        onHidden: ()=>{},
        vendorSubMenu: true,
        // variantProductData: productData,
        isVariant: true,
        variantIndex: imageIndex.current,
        containerInfo: props.uploadOptions.containerInfo,
        style: props.uploadOptions.style,
        data:{
            imageUrlArr: props.variantProductData[imageIndex.current]?.imageUrlArr
        },
        fromVideoListing: props.uploadOptions.fromVideoListing
    }

    // const uploadOptionProps = {
    //     type: props.uploadOptions.type,
    //     onFileUpload: res=>uploadImage(res),
    //     onHidden: ()=>{},
    //     vendorSubMenu: true,
    //     isVariant: true,
        
    //     variantIndex: imageIndex.current,
    //     containerInfo: props.uploadOptions.containerInfo,
    //     style: props.uploadOptions.style,
    //     data:{
    //         imageUrlArr: productData[imageIndex.current]?.imageUrlArr
    //     },
    //     fromVideoListing: props.uploadOptions.fromVideoListing
    // }

    const showViewMore = props.variantProductData.length > 10 && !showAll && props.itemInfo?.isEdit;
    const AddVariant = withRipple(props => {
        return(
        <div
            className={`${styles["section-container"]} ${props.rippleClass}`}
            {...props.rippleHandler}
            onClick={() => {
                if(props.allowVariant){
                    props.showVariantTypeSlider({show: true,mode: 'add', from: 'homepage'})
                }else{
                    setPremiumModal(true);
                }
            }}
        >
            <div className={styles["head-section"]}>
                <span>Add Variants</span> 
                {props.allowVariant ? '' : <img src='https://image1.jdomni.in/jdomni_email/Preium20_2008261653.png' className={styles['prem-tag']}/>}
                <i className={"icon-Next"}></i>
            </div>
            {props.renderRipple()}
        </div> 
      )
    });

    return(
        <>
            {props.variantProductData.length ? 
                <div
                    className={`${styles["section-container"]} ${showViewMore ? '' : styles['show-all']} no-border-bottom no-border-top variant-container`}
                >
                    <div className={styles['container-heading']}>
                        {props.variantProductData.length} Variants
                        {!props.session.isReadOnly ?  <div className={`${styles['button-toggle-holder']} ${(colorPresent) ? styles['with-toggle'] : ''}`}>
                            <Button 
                                clickHandler={onEditClick}
                                children='Edit'
                                size='xs'
                                variant='default'
                            />
                            {/* {(colorPresent) && <MoreMenu 
                                list={[{
                                    label: 'Settings',
                                    onClick: () => {
                                        props.showSettingsSlider(true)
                                    }
                                }]}
                            />} */}
                        </div> : null}
                    </div>
                    <VariantProductList 
                        hideProduct={props.itemInfo?.isEdit && !showAll}
                        productData={props.variantProductData}
                        isEdit={props.isEdit}
                        setMoreDetails={(index, item, titleStr)=>{
                            props.showMoreDetailsSlider({
                                show: true,
                                index: index,
                                productData: item,
                                titleStr: titleStr,
                                allProductData: props.variantProductData,
                                onSave: (data, index)=>{
                                    let temp = [...props.variantProductData]
                                    temp[index] = data;
                                    if(colorPresent && props.syncImages){
                                        temp = syncImageUpload(temp, props.variantCombinations, index)
                                    }
                                    props.setVariantProductData(temp);
                                }
                            })
                        }}
                        setProductData={(obj,index, productId=null)=>{
                            let temp = [...props.variantProductData]
                            if(JSON.stringify(temp[index]) != JSON.stringify(obj)) {
                                obj['isChanged'] = true;
                            }
                            temp[index] = obj;
                            if(colorPresent && props.syncImages){
                                temp = syncImageUpload(temp, props.variantCombinations, index)
                            }
                            props.setVariantProductData(temp);
                            if(props.session.viaOmni && productId) {
                                props.deleteVideoUrlIdsFromAllProducts({productId})
                            }
                        }}
                        setAllProductData={props.setVariantProductData}
                        variantCombinations={props.variantCombinations}
                        setImageIndex={(index)=>{imageIndex.current = index}}
                        uploadOptionProps={uploadOptionProps}
                        showUploadOptions={props.uploadOptions.sliderType == 'upload' && !props.variantProps.variantDetailsSlider}
                        showToastMessage={props.showToastMessage}
                        permissions={props.permissions}
                    />
                    {showViewMore ? 
                        <div 
                            className={styles['show-more']}
                            onClick={()=>setShowAll(true)}    
                        >
                            View {props.variantProductData.length-10} More Variants
                        </div> : null
                    }
                </div> : 
                <AddVariant {...props}/>
            }
            {premiumModal && 
                (props.deviceData.isMobile ? 
                    <UpgradeModal {...modalProps}/> :
                    <UpgradeModalWeb {...modalProps} />
                )
            }
        </>
    )
}

const mapStateToProps = (state,props) => {
    return{
        ...props,
        variantProductData: state.variants.variantProductData,
        variantData: state.variants.variantData,
        variantCombinations: state.variants.variantCombinations,
        uploadOptions: state.uploadOptions,
        variantProps: state.variants,
        syncImages: state.variants.syncImages,
        allowVariant: state.permissions?.packagePermissionData?.packageDetails?.Products?.Add_Variants?.status == 'VISIBLE',
        permissions: state.permissions,
        deviceData: state.deviceData,
        session: state.session
    }
}

export default connect(mapStateToProps,{
    showEditVariantSlider,
    showVariantTypeSlider,
    setVariantProductData,
    showMoreDetailsSlider,
    showSettingsSlider,
    updateVideoInLibrary,
    showToastMessage: toastMessageActions.showMessage,
    showVariantDetailsSlider,
    updateEditProductDetail,
    deleteVideoUrlIdsFromAllProducts
})(VariantSection)